import { DATA_GRID_COLUMN_TYPES } from "StandardsTable/modules/constants";
import {
  COURSE_BASED_GRADING,
  SUBJECT_BASED_GRADING,
} from "Constants/stringConstants";

export const ARCHIVAL_STATE_OPTIONS = [
  {
    id: "ALL",
    label: "common:all",
  },
  {
    id: "ACTIVE",
    label: "common:active",
  },
  {
    id: "ARCHIVED",
    label: "common:archived",
  },
];

export const FILTERS = {
  [COURSE_BASED_GRADING]: ["grades", "subjects", "tags", "archivalState"],
  [SUBJECT_BASED_GRADING]: ["grades", "tags", "archivalState"],
  null: ["grades", "tags", "archivalState"],
};

export const DEFAULT_STANDARD_FILTERS = {
  grades: [],
  subjects: [],
  tags: [],
  archivalState: "ACTIVE",
};

export const STANDARD_COLUMNS = [
  DATA_GRID_COLUMN_TYPES.SELECTION,
  DATA_GRID_COLUMN_TYPES.CODE,
  DATA_GRID_COLUMN_TYPES.TITLE,
  DATA_GRID_COLUMN_TYPES.LIST_PARENT,
  DATA_GRID_COLUMN_TYPES.POWER_STANDARD,
  DATA_GRID_COLUMN_TYPES.GRADE_LEVELS,
];
